export default {
  "bank-container": "_bank-container_e4dtgr",
  "logo-container": "_logo-container_e4dtgr",
  "logo-icon": "_logo-icon_e4dtgr"
};
